/**
 * Default values for the config file located in the environments folder
 */
export class ConfigService {
  public changelog;
  public appName = 'geology';
  public AGSVersion = '10.7';
  public AppVersion = '';
  public pageTitle = 'DNR Viewer';
  public appAccessType = 'public';
  public logoBanner = 'https://fortress.wa.gov/dnr/geologydata/photos/em_dnr_logo_white_PNG.png';
  public logoUrl = 'http://www.dnr.wa.gov/geology';
  public appContactInfo;
  public appWebLinks;
  public tools = [{
    id: 'toc',
    name: 'Table of Contents',
    openByDefault: true,
    visible: 'visible',
    width: '45px',
    iconWidth: '20px',
    padding: '15px',
    margin: '5px',
    position: 1,
    status: 'widget-on',
    icon: './assets/widget-bar/',
    button: 'vis',
    grid: false
  }, {
    id: 'identify',
    name: 'Identify',
    visible: 'visible',
    width: '45px',
    iconWidth: '20px',
    padding: '15px',
    margin: '5px',
    position: 1,
    status: 'widget-on',
    icon: './assets/widget-bar/',
    button: 'vis',
    grid: false
  }, {
    id: 'feedback',
    name: 'Feedback',
    message: 'Please provide us with feedback. You can send us an email or take a survey',
    email: ['Michael.Tonkel@dnr.wa.gov'],
    survey: 'https://www.surveymonkey.com/r/WGSportal'
    }];
  public appTools = [];
  public initialTheme = '';
  public themeUrlParameters;
  public CurrentTheme = '';
  public Themes;
  public serviceSwatchPath = '';
  public themeLayerProperties;
  public themeLayers;
  public themesInfo;
  public search = [];
  public themeTOCNodeFileName;
  public geometryServer = '';
  public hasMultipleThemes: boolean;
  public themeNameList = [];
  public printMapTool: any;
  public queryTasks: any;
  public themeQueryTasks: any;
  public swatchLegendDictionary: any;
  public appHref: string;
  public DNRProgramWebsite: string;
  public gtag = '';
  public mapInitialLayer = 'streets';
  public mapInitialLayerVisible = true;
  public mapInitialCenter = [-120, 47.5];
  public mapInitialZoomLevel = 7.5;
  public defaultVisibleLayers;
  public tocNodeArray;
  public portalToken;
  public portalCredential;
  public doNotPrintLayerList;
  public USGSTopoMaps;
  public nonToolbarWidgets;
  public closeToolsOnThemeSwitch;
  public WtmfPDFInfo;
  public helpImage;
  public removeServiceNamesFromLegend = false;
  public dashboardInfo;
}
